import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from '@paypalcorp/pp-react'
import glamorous from 'glamorous'
import { Link } from 'react-router-dom'
import { trackAction } from '../../../utils/analytics'
import { Message } from '@paypalcorp/worldready-react'

const Section = glamorous.section({
  padding: '23px 0',
  verticalAlign: 'middle',
  display: 'table',
  maxWidth: '929px',
  '@media only screen and (max-width: 768px)': {
    padding: '13px 0',
    // applying negative margin to counter .mainContent style in global.css
    //marginTop: '-72px',
  },
})

const BackLinkStyle = {
  display: 'table-cell',
  textAlign: 'left',
  fontSize: '20px',
  fontWeight: '100',
  textDecoration: 'none',
  lineHeight: 'normal',
  color: '#0070ba',
  cursor: 'pointer',
}

const triggerFPTI = (pagename) => {
  trackAction(`backLink:Page:${pagename}`)
}

const GoBackLink = (props) => {
  const { cssStyle, path, isInternal, pagename } = props
  return (
    <Section
      className="container"
      style={cssStyle}
      onClick={() => triggerFPTI(pagename)}
    >
      {isInternal ? (
        <Link to={path} style={{ textDecoration: 'none' }}>
          <span href={path} style={BackLinkStyle}>
            <Icon name="arrow-left" size="md" style={{ color: '#0070ba' }} />
            <Message id="pages/all-gift-cards.categories.backLinkText" />
          </span>
        </Link>
      ) : (
        <a href={path} style={BackLinkStyle}>
          <Icon name="arrow-left" size="md" style={{ color: '#0070ba' }} />
          <Message id="pages/all-gift-cards.categories.backLinkText" />
        </a>
      )}
    </Section>
  )
}

GoBackLink.propTypes = {
  path: PropTypes.string,
  cssStyle: PropTypes.object,
  isInternal: PropTypes.bool,
  pagename: PropTypes.string,
}

export default GoBackLink
